module.exports = __webpack_public_path__ + "static/banner_resources_tablet-e5e02f1a75a0a3214eb10ade23430870.png";